import {
  CODE_SESSIONS_LIST_QUERY_KEY,
  DEFAULT_CODE_SESSIONS_LIST_LIMIT,
  DEFAULT_CODE_SESSIONS_LIST_OFFSET,
} from "@frontend-shared/constants";
import type { ICodeSessionListItem } from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";

import { codeSessionApi } from "@/api/services";

export const useCodeSessionList = (): ReturnType<
  typeof useQuery<ICodeSessionListItem[], Error>
> => {
  return useQuery({
    queryKey: [CODE_SESSIONS_LIST_QUERY_KEY],
    queryFn: () =>
      codeSessionApi.getCodeSessionList({
        limit: DEFAULT_CODE_SESSIONS_LIST_LIMIT,
        offset: DEFAULT_CODE_SESSIONS_LIST_OFFSET,
      }),
  });
};
